export default {
  "Mandai Rainforest Park": {
    name: "Mandai Rainforest Park",
    projectType: "Theme Park Project",
    developer: "",
    tenure: "",
    psf: "",
    completionYear: "2024",
    totalUnits: "",
    desc: "The Mandai Rainforest Park is MCC Singapore’s second major integrated theme park project. Located along Mandai Lake Road, facing the new Bird Park, it will also feature walking trails and visitors can expect to set out on a multi-layered adventure in the new 12.5-ha Rainforest Park on the forest floor pathways to the tree-top canopies. With ongoing reforestation works expected to take place in this area, the Mandai Rainforest Park will only be fully open in 2024. As an integral part of the Mandai Project and the world’s first rainforest theme park, the Mandai Rainforest Park will serve as a sanctuary for Southeast Asia’s endangered animal and plant species, becoming an important hub for environmental education and research in Asia.",
    website:"",
    location: {lat: 1.4063078477059157, lng: 103.7854188459452},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/mandai/rain-forest.gif')},
      {id: 1, imageSrc: require('@/assets/images/constructions/mandai/DJI_0867.gif')},
    ]
  },
  "Normanton Park": {
    name: "Normanton Park",
    projectType: "Condominium",
    developer: "",
    tenure: "",
    psf: "63,685m²",
    completionYear: "04 February 2022",
    totalUnits: "",
    desc: `The luxury condominium project has a total construction area of 63,685 square metres, a total gross floor area of 146,900 square metres and a plot ratio of 2.1. The 99-year leasehold project comprises nine blocks of 24-storey residential flats and 23 units of two-storey strata terrace, one unit of restaurant and seven units of shops with two basement car park, a swimming pool and communal facilities. The project commenced work in 2018 with completion slated for 2022.
    `,
    website:"",
    location: {lat: 1.28804920671209, lng: 103.79291280298733},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/normanton-park/Normanton-Park-Drone-View.gif')},
      {id: 1, imageSrc: require('@/assets/images/constructions/normanton-park/normanton-park-v4-singapore-scaled.gif')},
      {id: 2, imageSrc: require('@/assets/images/constructions/normanton-park/DJI_0564.gif')},
      {id: 3, imageSrc: require('@/assets/images/constructions/normanton-park/DJI_0569.gif')},
    ]
  },
  "Changi East Depot": {
    name: "Changi East Depot",
    projectType: "Infrastructural Project",
    developer: "",
    tenure: "",
    psf: "",
    completionYear: "2030",
    totalUnits: "",
    desc: `A project awarded by the Land Transport Authority (LTA) of Singapore, the Changi East Depot designed and constructed by MCC Singapore, with China Jingye Engineering Corporation Limited (Singapore Branch) as the contractor, will be the second LTA-related project undertaken by the company since the Bedok South Station and Tunnels project for the Thomson-East Coast Line (TEL). The 57-hectare Changi East Depot, located near Changi Exhibition Centre, will house the Operations Control Centre (OCC) and provide stabling and maintenance facilities for 70 Cross Island Line (CRL) trains. Construction works for the Changi East Depot commences in 2021 with completion slated for 2030.
    
    The Cross Island Line (CRL) is Singapore’s eighth MRT line and will be the longest fully underground line at more than 50 kilometres long. CRL Phase 1, covering 29 kilometres long with 12 MRT stations, is scheduled to be completed by 2030.`,
    website:"",
    location: {lat: 1.3291295472060718, lng: 103.96094150912188},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/changi-east/10-6b.jpg')},
      {id: 1, imageSrc: require('@/assets/images/constructions/changi-east/10-7.jpg')},
      {id: 2, imageSrc: require('@/assets/images/constructions/changi-east/10-8.jpg')},
      {id: 3, imageSrc: require('@/assets/images/constructions/changi-east/10-9.jpg')},
      {id: 4, imageSrc: require('@/assets/images/constructions/changi-east/10-10.jpg')},
    ]
  },
  "T311 Bedok South Station": {
    name: "T311 Bedok South Station",
    projectType: "Infrastructural Project",
    developer: "",
    tenure: "",
    psf: "19,907.84m²",
    completionYear: "2024",
    totalUnits: "",
    desc: `
    A project awarded by the Land Transport Authority (LTA) of Singapore, the Bedok South Station and Tunnels have a land area of 24,274.01 square metres, a total construction area of 19,907.84 square metres and a plot ratio of 0.82. Designed and constructed by China Jingye Engineering Corporation Limited (Singapore Branch), the Bedok South Station and Tunnels project is an underground station with tunnels spanning 270 metres. Together with Bayshore, Marine Parade, Marine Terrace, Siglap and Tanjong Rhu stations, Bedok South station will serve as the sixth Civil Defence shelter along the East Coast stretch of Thomson-East Coast Line (TEL). Works for the Bedok South Station and Tunnels commenced in 2016 with completion slated for 2025. The 13-kilometre East Coast stretch of the Thomson-East Coast Line (TEL) will connect commuters living in the eastern parts of Singapore and who are not directly served by the rail network currently, such as those in Tanjong Rhu, Siglap, Marine Parade, Upper East Coast and Bedok South, to the heart of the city. As part of the 43-kilometre long TEL, the East Coast stretch will also connect commuters to the Thomson stretch of the TEL, which serves the North-South Corridor. The East Coast stretch will have nine stations, including a station that interchanges with the Downtown Line at Sungei Bedok. The East Coast stretch of the TEL will be completed in two stages. The first seven stations from Tanjong Rhu to Bayshore will be ready in 2023, while the remaining two stations (Bedok South and Sungei Bedok) will be completed in 2025. 
`,
    website:"",
    location: {lat: 1.3170754472866142, lng: 103.95086916249531},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/t311/1.jpg')},
      {id: 1, imageSrc: require('@/assets/images/constructions/t311/1.jpg')}
    ]
  },
  "Jalan Papan Factory & Office": {
    name: "Jalan Papan Factory & Office",
    projectType: "Public and Industrial Construction Project",
    developer: "",
    tenure: "",
    psf: "6,600m²",
    completionYear: "2023",
    totalUnits: "",
    desc: `The 6,600-square-meter project, scheduled for completion in 2023, will consist of two linked main buildings-- an office building and a steel factory. The six-story office building includes a parking lot, an in-house cafeteria, a multi-purpose hall, a roof garden, a koi pond and other facilities with a view of the Jurong River. The in-house cafeteria on the second floor will serve meals to employees working in the office and provide meal service to workers in various projects of the company. The multi-function hall on the fifth floor will hold various staff activities on a regular basis.`,
    website:"",
    location: {lat: 1.3227987, lng: 103.7266427},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/jalan-papan/图片4.jpg')},
      {id: 0, imageSrc: require('@/assets/images/constructions/jalan-papan/图片2.png')},
      {id: 0, imageSrc: require('@/assets/images/constructions/jalan-papan/图片3.png')},
    ]
  },
  "Short Street Hotel": {
    name: "Short Street Hotel",
    projectType: "Public and Industrial Construction Project",
    developer: "",
    tenure: "",
    psf: "2,251m²",
    completionYear: "",
    totalUnits: "528",
    desc: "The Short Street Hotel project covers an area of 2,251 square metres, with a construction area of 11,160 square metres. The building comprises 14 floors, one basement level and a total of 528 guest rooms. Located near an MRT station and only five to six metres away from the heritage conservation area, the project commenced work in 2020 with completion slated for 2022.",
    website:"",
    location: {lat: 1.3027459, lng: 103.8486727},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/short-street/ShortSt_trim01.gif')},
    ]
  },
}